/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_M_Add_DescInputs */

const es_nav_m_add_desc = /** @type {(inputs: Nav_M_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publica tu embarcación`)
};

const gl_nav_m_add_desc = /** @type {(inputs: Nav_M_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publica a túa embarcación`)
};

const en_nav_m_add_desc = /** @type {(inputs: Nav_M_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List your vessel`)
};

/**
* | output |
* | --- |
* | "List your vessel" |
*
* @param {Nav_M_Add_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_m_add_desc = /** @type {((inputs?: Nav_M_Add_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_M_Add_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_m_add_desc(inputs)
	if (locale === "en") return en_nav_m_add_desc(inputs)
	return es_nav_m_add_desc(inputs)
});